import { render, staticRenderFns } from "./SurveyLanguageStatus.vue?vue&type=template&id=c0aeb9b0&scoped=true"
import script from "./SurveyLanguageStatus.vue?vue&type=script&lang=js"
export * from "./SurveyLanguageStatus.vue?vue&type=script&lang=js"
import style0 from "./SurveyLanguageStatus.vue?vue&type=style&index=0&id=c0aeb9b0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0aeb9b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0aeb9b0')) {
      api.createRecord('c0aeb9b0', component.options)
    } else {
      api.reload('c0aeb9b0', component.options)
    }
    module.hot.accept("./SurveyLanguageStatus.vue?vue&type=template&id=c0aeb9b0&scoped=true", function () {
      api.rerender('c0aeb9b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/SurveyLanguageStatus.vue"
export default component.exports